import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-container">
      <button className="back-button" onClick={() => navigate('/')}>← Back to Home</button>
      
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: February 1, 2026</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using Jollyio ("the Website"), you accept and agree to be bound by these Terms of Service. 
          If you do not agree to these terms, please do not use the Website.
        </p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>
          Jollyio is an informational website that aggregates and displays information about kid-friendly events, 
          activities, camps, classes, and attractions in the Houston metro area. We collect this information from 
          publicly available sources including libraries, parks, school districts, and other venues.
        </p>
      </section>

      <section>
        <h2>3. No Warranty</h2>
        <p>
          The information on Jollyio is provided "as is" for informational purposes only. We make no warranties, 
          expressed or implied, regarding:
        </p>
        <ul>
          <li>The accuracy, completeness, or timeliness of event information</li>
          <li>The availability of events or changes to event schedules</li>
          <li>Pricing, registration requirements, or venue details</li>
        </ul>
        <p>
          <strong>You are responsible for verifying all event details directly with event organizers before attending.</strong>
        </p>
      </section>

      <section>
        <h2>4. Limitation of Liability</h2>
        <p>
          Jollyio is not responsible for:
        </p>
        <ul>
          <li>Event cancellations, changes, or inaccuracies in event information</li>
          <li>Issues arising from attending events listed on our Website</li>
          <li>Third-party websites or services linked from Jollyio</li>
          <li>Any injuries, damages, or losses incurred while attending events</li>
        </ul>
      </section>

      <section>
        <h2>5. User Accounts</h2>
        <p>
          To use certain features (such as saving favorites), you must create an account. You agree to:
        </p>
        <ul>
          <li>Provide accurate and complete information</li>
          <li>Maintain the security of your account credentials</li>
          <li>Be at least 13 years of age (in compliance with COPPA)</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
        </ul>
      </section>

      <section>
        <h2>6. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Scrape, crawl, or systematically download content from the Website</li>
          <li>Use the Website for any illegal or unauthorized purpose</li>
          <li>Attempt to gain unauthorized access to our systems</li>
          <li>Interfere with or disrupt the Website's operation</li>
          <li>Misrepresent your identity or affiliation</li>
        </ul>
      </section>

      <section>
        <h2>7. Intellectual Property</h2>
        <p>
          The Jollyio name, logo, and website design are owned by Jollyio. Event information is sourced from 
          public sources and belongs to the respective event organizers. You may not reproduce, distribute, 
          or create derivative works from our Website without permission.
        </p>
      </section>

      <section>
        <h2>8. Third-Party Links</h2>
        <p>
          Our Website contains links to third-party websites (event registration pages, venue websites, etc.). 
          We are not responsible for the content, privacy practices, or terms of these external sites.
        </p>
      </section>

      <section>
        <h2>9. Data Collection</h2>
        <p>
          We collect information about kid-friendly events from publicly available sources including library websites, 
          park district calendars, school district websites, and venue pages. Our use of your personal data is 
          governed by our <a href="/privacy-policy">Privacy Policy</a>.
        </p>
      </section>

      <section>
        <h2>10. Termination</h2>
        <p>
          We reserve the right to terminate or suspend your account and access to the Website at our discretion, 
          without notice, for conduct that violates these Terms or is harmful to other users or the Website.
        </p>
      </section>

      <section>
        <h2>11. Changes to Terms</h2>
        <p>
          We may update these Terms of Service at any time. Continued use of the Website after changes 
          constitutes acceptance of the modified terms.
        </p>
      </section>

      <section>
        <h2>12. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the State of Texas, United States. Any disputes shall be 
          resolved in the courts of Harris County, Texas.
        </p>
      </section>

      <section>
        <h2>13. Contact Us</h2>
        <p>
          If you have questions about these Terms of Service, please contact us at: <strong>support@jollyio.com</strong>
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
